import stateFarmLogoUrl from "./img/state-farm-logo.svg";
import { isStateFarmPartner, Partner } from "shared";
import styles from "./PartnerLogo.module.scss";

type PartnerLogoProps = {
  partner: Partner;
};

export const PartnerLogo = ({ partner }: PartnerLogoProps) => {
  if (isStateFarmPartner(partner)) {
    return (
      <div
        className={styles.container}
        aria-hidden="true"
        aria-label="State Farm logo"
      >
        <img src={stateFarmLogoUrl} alt="State Farm logo" />
      </div>
    );
  }

  return null;
};
